import convert from 'color-convert';
import { RGBColor, HSLColor, Color, ColorResult } from 'react-color';

export const hexToRgb = (hex: string): RGBColor => {
  const result = convert.hex.rgb(hex);
  return {
    r: result[0],
    g: result[1],
    b: result[2],
  };
};

export const hexToHsl = (hex: string): HSLColor => {
  const result = convert.hex.hsl(hex);
  return {
    h: result[0],
    s: result[1],
    l: result[2],
  };
};

export const hexToColor = (
  hex: string
): { hex: string; hsl: HSLColor; rgb: RGBColor } => {
  return {
    hex,
    hsl: hexToHsl(hex),
    rgb: hexToRgb(hex),
  };
};

export const isHex = (string: string): boolean =>
  /^#[0-9A-F]{6}$/i.test(string);

export const isRGBColor = (color: Color | ColorResult): color is RGBColor =>
  typeof color === 'object' && (color as RGBColor).r !== undefined;

export const isHSLColor = (color: Color | ColorResult): color is HSLColor =>
  typeof color === 'object' && (color as HSLColor).h !== undefined;

export const isColorResult = (
  color: Color | ColorResult
): color is ColorResult =>
  typeof color === 'object' && (color as ColorResult).hex !== undefined;

// type HSLColor = {r, g, b, a?} (all numbers)
// type RGBColor = {h, s, l, a?} (all numbers)
// type Color = string | HSLColor | RGBColor;
// type ColorResult = {hex: string, hsl: HSLColor, rgb: RGBColor};
export const convertColorToString = (color: Color | ColorResult): string => {
  if (typeof color === 'string') return color;

  // Wrapped color result, return the hex string value
  if (isColorResult(color)) return color.hex;

  // RGB Color result, build a rgb(a) string value
  if (isRGBColor(color)) {
    if (color.a === undefined)
      return `rgb(${[color.r, color.g, color.b].join(',')})`;
    return `rgba(${[color.r, color.g, color.b, color.a].join(',')})`;
  }

  // HSL Color result, build a hsl(a) string value
  if (isHSLColor(color)) {
    if (color.a === undefined)
      return `hsl(${[color.h, color.s, color.l].join(',')})`;
    return `hsla(${[color.h, color.s, color.l, color.a].join(',')})`;
  }
  // Should never happen
  throw new Error('Cannot convert to string: Unsupported color type');
};
